<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование компании" : "Добавление компании"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12)
          s-address-suggest(
            :error='errors.has("address_full")'
            :error-messages='errors.first("address_full")'
            @change='onAddressSuggestChange'
            v-model='item.address_full'
          )
        v-flex(xs6)
          v-text-field(
            :error='errors.has("address_geo_lat")'
            :error-messages='errors.first("address_geo_lat")'
            v-model='item.lat'
            label='Широта'
          )
        v-flex(xs5)
          v-text-field(
            :error='errors.has("address_geo_lon")'
            :error-messages='errors.first("address_geo_lon")'
            v-model='item.lon'
            label='Долгота'
          )
        v-flex(xs1)
          v-btn(icon @click.stop='onCoordinatesDelete')
            v-icon(small) delete_outline
        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("director")'
            :error-messages='errors.first("director")'
            v-model='item.director'
            label='Директор'
          )
        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("site")'
            :error-messages='errors.first("site")'
            :rules='[rules.url]'
            v-model='item.site'
            label='Ссылка на сайт'
          )
        v-flex(xs12)
            span(class='subheading font-weight-medium') Контактные телефоны
            v-btn(@click='onAddContact' small flat color='primary')
              v-icon(small left) add
              | Добавить
        v-flex(xs12)
          v-layout(wrap)
            v-flex(
              v-for='(contact, index) in contacts'
              :key='index'
              xs12 md3
            )
              s-phone-input(
                @input='onContactChange($event, index)'
                @click:append='onRemoveContact(index)'
                :value='contact'
                label='Номер телефона'
                append-icon='close'
              )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("work_time")'
            :error-messages='errors.first("work_time")'
            v-model='item.work_time'
            label='Режим работы'
          )
        v-flex(xs12)
          div(class='subheading font-weight-medium mb-3') Описание
          ckeditor(v-model='item.about')
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.avatar_url'
            @remove='onRemoveAvatar'
            v-model='item.avatar'
            label='Картинка компании'
          )
        v-flex(xs12 sm4)
          s-image-upload(
            :src='item.logo_url'
            @remove='onRemoveAvatar'
            v-model='item.logo'
            label='Логотип компании'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { isUrlValid } from '@/utils'
import { isObject } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor')
  },

  data: () => ({
    item: {},
    avatar: null,
    focused: false,
    rules: {
      url: val => {
        if (val && !isUrlValid(val)) {
          return 'Некорректный url'
        }
        return true
      }
    },
    contacts: [null],
    maxContacts: 10,
    changeCoords: false
  }),

  async created() {
    if (this.id) {
      this.item = (await this.fetchSingle({ id: this.id })).data
      this.contacts = this.item.contacts ? this.item.contacts.split(/,/) : []
      if (!this.item.lat && !this.item.lon) {
        this.changeCoords = true
      }
    } else {
      this.changeCoords = true
    }
  },

  methods: {
    onCoordinatesDelete() {
      this.changeCoords = true
      this.item.lat = null
      this.item.lon = null
      this.item = Object.assign({}, this.item)
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Компания сохранена')
        this.$router.push({ name: 'Admin.ManCompanies' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    onAddressSuggestChange({ data, value, unrestricted_value }) {
      let coords = {}
      if (this.changeCoords) {
        coords.lat = data.geo_lat
        coords.lon = data.geo_lon
      }

      this.item = Object.assign({}, this.item, {
        dadata: {
          ...data,
          value,
          unrestricted_value
        },
        address_full: value,
        address_fias_id: data.fias_id
      }, coords)
    },

    onRemoveLogo() {
      this.item.logo = null
    },

    onRemoveAvatar() {
      this.item.avatar = null
    },
    onContactChange(value, index) {
      this.contacts[index] = value
    },

    onRemoveContact(index) {
      this.contacts.splice(index, 1)
    },

    onAddContact() {
      if (this.contacts.length < this.maxContacts) {
        this.contacts.push(null)
      }
    },

    createFormData() {
      let data = new FormData()

      if (null !== this.avatar) {
        data.append('avatar', this.avatar)
      }

      if (this.contacts.length) {
        this.item.contacts = this.contacts.filter(c => c).join(',')
      }

      Object.keys(this.item).forEach(key => {
        data.append(
          key,
          isObject(this.item[key])
            ? JSON.stringify(this.item[key])
            : this.item[key]
        )
      })

      return data
    },

    ...mapActions('admin/manCompanies', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('admin/manCompanies', ['isLoading'])
  }
}
</script>
